module.exports = __webpack_public_path__ + "static/media/glyphstats_logo.9f6749a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glyphstats_logo.png
// module id = 219
// module chunks = 1